import React, { createContext, useContext, useReducer, useEffect } from "react";
import { getProgress } from "../services/progressService";
import challengesData from "../data/challenges.json";

const AppContext = createContext();

const initialState = {
  user: null,
  currentChallenge: null,
  completedChallenges: [],
  isLoadingProgress: false,
};

const appReducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };

    case "SET_COMPLETED":
      return { ...state, completedChallenges: action.payload };

    case "SET_LOADING_PROGRESS":
      return { ...state, isLoadingProgress: action.payload };

    case "COMPLETE_CHALLENGE":
      if (state.completedChallenges.includes(action.payload)) return state;
      return {
        ...state,
        completedChallenges: [...state.completedChallenges, action.payload],
      };

    default:
      return state;
  }
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  useEffect(() => {
    if (state.user) {
      dispatch({ type: "SET_LOADING_PROGRESS", payload: true });
      const loadProgress = async () => {
        const completed = [];
        for (let i = 1; i <= challengesData.challenges.length; i++) {
          const data = await getProgress(state.user.uid, i);
          if (data?.isComplete) completed.push(i);
        }
        dispatch({ type: "SET_COMPLETED", payload: completed });
        dispatch({ type: "SET_LOADING_PROGRESS", payload: false });
      };
      loadProgress();
    } else {
      dispatch({ type: "SET_COMPLETED", payload: [] });
      dispatch({ type: "SET_LOADING_PROGRESS", payload: false });
    }
  }, [state.user]);

  const setUser = (user) =>
    dispatch({ type: "SET_USER", payload: user });

  const completeChallenge = (id) =>
    dispatch({ type: "COMPLETE_CHALLENGE", payload: id });

  return (
    <AppContext.Provider
      value={{
        ...state,
        setUser,
        completeChallenge,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);